import { styled } from '@mui/material/styles';
import MuiChip from '@mui/material/Chip';
import TextFieldBase from 'components/mui/Form/TextField/TextFieldBase';

// Lays out the OutlinedInput as a single flex row that hosts the chip strip inline before the
// growing text field. Uses the default outlined-input corner radius (per design), not a pill.
// Scoped to Workspace; never the shared base.
export const SearchField = styled(TextFieldBase)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: theme.shape.borderRadius, // default squared corners (design)
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
}));

// Truncating filter chip: ellipsis when the label doesn't fit (full text via Tooltip).
export const FilterChip = styled(MuiChip)(({ theme }) => ({
  maxWidth: theme.spacing(25), // ~200px, token-driven; tunable (Q1)
  '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
}));
